import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useFieldCorrections } from '@/hooks/api/useFieldCorrections';
import { useMapStore } from '@/stores/mapStore';

export const useCorrectionOverlaySync = () => {
  const [searchParams] = useSearchParams();
  const dialogType = searchParams.get('dialog');
  const ticketId = searchParams.get('ticketId') ?? '';

  const isTicketOpen = dialogType === 'edit-ticket' && !!ticketId;

  const { data: corrections } = useFieldCorrections(
    isTicketOpen ? ticketId : '',
  );

  const prevTicketIdRef = useRef('');

  useEffect(() => {
    const { setOverlayCorrections, clearOverlay } = useMapStore.getState();

    if (isTicketOpen && corrections.length > 0) {
      if (prevTicketIdRef.current !== ticketId) {
        setOverlayCorrections(corrections);
        prevTicketIdRef.current = ticketId;
      }
    } else if (!isTicketOpen && prevTicketIdRef.current) {
      clearOverlay();
      prevTicketIdRef.current = '';
    }
  }, [isTicketOpen, ticketId, corrections.length]);

  useEffect(() => {
    return () => useMapStore.getState().clearOverlay();
  }, []);
};
